import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import {
  callActionApiAsync,
  postSaveBiomedicalEquipmentModelAccessory
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";
import { icons } from "../../../constants";
import AddAccessory from "../modals/addAccessory";

const validationSchema = yup.object({
  accessoryId: yup
    .number()
    .typeError("El accesorio es obligatorio")
    .required("El accesorio es obligatorio")
});

const defaultValues = {
  accessoryId: ""
};

const ModelAccessoriesModal = ({
  open,
  close,
  modelId,
  brandId,
  userId,
  accessoryOptions,
  setAccessoryOptions,
  selectedRow,
  onSaved,
  isViewer
}) => {
  const [showToast, setShowToast] = useState(false);
  const [openAddAccessoryModal, setOpenAddAccessoryModal] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warn",
    summary: "",
    detail: ""
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues
  });

  useEffect(() => {
    if (!open) return;

    reset(
      selectedRow
        ? {
            accessoryId: selectedRow.accessoryId || ""
          }
        : defaultValues
    );
  }, [open, reset, selectedRow]);

  const handleClose = () => {
    reset(defaultValues);
    close();
  };

  const onSubmit = async (formData) => {
    await callActionApiAsync(
      () =>
        postSaveBiomedicalEquipmentModelAccessory({
          id: selectedRow?.id || 0,
          userId,
          modelId,
          accessoryId: formData.accessoryId
        }),
      () => {
        onSaved?.();
        handleClose();
      },
      (error) => {
        setToastConfig({
          severity: "error",
          summary: "Accesorios por modelo",
          detail:
            typeof error === "string" && error
              ? error
              : "No se pudo guardar el accesorio del modelo."
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title={
          selectedRow ? "Editar accesorio del modelo" : "Agregar accesorio al modelo"
        }
        actions={<div className="HContainer j-center w-complete mt-10"></div>}
        maxWidth="620px"
      >
        <ToastNotification
          showToast={showToast}
          setShowToast={setShowToast}
          severity={toastConfig.severity}
          summary={toastConfig.summary}
          detail={toastConfig.detail}
        />

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={10} md={10}>
              <p className="create-label">Accesorio:</p>
              <SimpleSelect
                name="accessoryId"
                control={control}
                options={accessoryOptions}
                hideLabel
                error={errors.accessoryId}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item xs={2} md={2} className="VContainer align-end">
              {!isViewer && (
                <LaddaButton
                  width={"40px"}
                  fontSize={"12px"}
                  height={"40px"}
                  variant="contained"
                  margin={"0"}
                  onClick={() => {
                    if (brandId) {
                      setOpenAddAccessoryModal(true);
                    }
                  }}
                >
                  <img className="btn-icon" src={icons.plusIcon} alt="icon" />
                </LaddaButton>
              )}
            </Grid>
            <Grid item xs={12} className="HContainer j-center mt-15">
              <LaddaButton type="submit" variant="contained" disabled={isViewer}>
                {selectedRow ? "Guardar accesorio" : "Agregar accesorio"}
              </LaddaButton>
            </Grid>
          </Grid>
        </form>
      </ModalComponent>

      <AddAccessory
        open={openAddAccessoryModal}
        close={() => setOpenAddAccessoryModal(false)}
        setAccessoryOptions={setAccessoryOptions}
        brandIdSelected={brandId}
        accessoryOptions={accessoryOptions}
      />
    </>
  );
};

export default ModelAccessoriesModal;
